import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Checkbox from '../../Form/Checkbox';
import DraggableList from '../../DraggableList';
import PostListItem from './PostListItem';
import slugify from '../../../utils/slugify';

import postDeletePost from '../../../api/graphql/mutations/postDeletePost';
import postEditPost from '../../../api/graphql/mutations/postEditPost';
import massPostModif from '../../../api/graphql/mutations/massPostModif';
import getPostBySlug from '../../../api/graphql/queries/getPostBySlug';
import postAddPost from '../../../api/graphql/mutations/postAddPost';
import checkPostSlugNameRepeated from '../../../utils/checkPostSlugNameRepeated';

import Modal from '../../Modal/Modal';

class PostsList extends Component {
  state = {
    isDeleteModuleOn: false,
    isDeleteConfirmationModuleOn: false,
    isDuplicatingModuleOn: false,
    slugName: '',
    id: '',
    statusText: '',
    postItemsSelected: [],
    allChecked: false,
    disableCheckBoxes: false,
    duplicatedPost: {},
    postSlugNames: [],
    currentPage: 0,
    currentPageValue: 0,
    pageSize: 20,
  };

  componentDidMount = () => {
    const { posts } = this.props;
    if (posts.length) {
      const postSlugNames = posts.map(p => p.slugName);
      this.setState({ postSlugNames });
    }
  }


  handleDragEnd = () => {
    console.log('done dragging');
  };

  handleDeleteModule = (slugName, id) => {
    this.setState({ isDeleteModuleOn: true });
    this.setState({ slugName, id });
  };

  handleDelete = () => {
    const { updatePostsList } = this.props;
    const { slugName, id } = this.state;
    this.setState({ isDeleteModuleOn: true });
    if (slugName) {
      const postData = {
        slugName,
        id,
      };

      postDeletePost(postData).then((deletePostResultData) => {
        if (deletePostResultData.isDeleted) {
          updatePostsList();
          this.setState({ isDeleteModuleOn: false });
          this.setState({ statusText: 'Post has been succesfully deleted' });
          this.setState({ isDeleteConfirmationModuleOn: true });
        } else {
          this.setState({ isDeleteModuleOn: false });
          this.setState({ statusText: 'Post was not deleted, please contact your administrator' });
          this.setState({ isDeleteConfirmationModuleOn: true });
        }
      });
    }
  };

  handleSelected = (item, isChecked) => {
    if (item) {
      const { postItemsSelected } = this.state;
      if (isChecked) {
        postItemsSelected.push(item);
        this.setState({
          postItemsSelected,
        });
      } else if (!isChecked) {
        const index = postItemsSelected.indexOf(item);
        if (index >= 0) {
          postItemsSelected.splice(index, 1);
          this.setState({ postItemsSelected });
        }
      }
    }
  };

  handleArrayActivation = async (makePubl) => {
    const { postItemsSelected } = this.state;
    const { updatePostsList } = this.props;

    if (postItemsSelected.length) {
      this.setState({ disableCheckBoxes: true });
      try {
        const obj = {};
        obj.posts = postItemsSelected;
        obj.publish = makePubl;
        const res = await massPostModif(obj);
        const { isEdited } = res;
        if (isEdited) {
          updatePostsList();
        } else {
          console.log('Admin: there was an issue updating the posts in mass, please contact your admin');
        }
      } catch {
        err => console.log(err);
      }
      this.setState({ disableCheckBoxes: false });
    }
  }

  handleDuplicate = (slugname) => {
    getPostBySlug(slugname).then((res) => {
      if (res) {
        const { post } = res;
        this.setState({ isDuplicatingModuleOn: true, duplicatedPost: post, slugName: slugname });
      }
    }).catch(err => console.log(err));
  }

  handleSetNewSlugName = (e) => {
    const { duplicatedPost } = this.state;
    const { value, name } = e.target;
    const slugName = slugify(value);
    const postDescription = {
      ...duplicatedPost.postDescription,
      url: `/${duplicatedPost.postCategory[0]}/${slugName}`,
      title: { en: value },
      date: new Date(),
    };
    const postState = {
      ...duplicatedPost,
      [name]: slugName,
      postName: value,
      postDescription,
      active: false,
    };
    this.setState({ duplicatedPost: postState });
  }

  handleDuplicatedPostSave = async () => {
    const { duplicatedPost } = this.state;
    const slugNameRepeated = await checkPostSlugNameRepeated(duplicatedPost.slugName);
    if (!slugNameRepeated) {
      postAddPost(duplicatedPost)
        .then(({ isAdded, slugName }) => {
          if (!isAdded) {
            // setStatus({ status: 'error', text: 'Post was not added', color: 'red' });
            console.log('not added', slugName);
          } else {
            // setStatus({ status: 'created' });
            this.props.history.push(`/cms/structure/${duplicatedPost.postCategory[0]}/${duplicatedPost.slugName}`);
          }
        })
        .catch(err => console.log(err));
    } else {
      this.setState({ statusText: 'SlugName is already taken' });
    }
  }

  handleAllCheckedChange = () => {
    const { allChecked, postSlugNames } = this.state;

    if (!allChecked) {
      this.setState({ postItemsSelected: postSlugNames });
    } else {
      this.setState({ postItemsSelected: [] });
    }

    this.setState({ allChecked: !allChecked });
  };

  showPosts = (post, index) => {
    const {
      postCategory,
      reusablePosts,
      posts,
    } = this.props;

    const {
      allChecked,
      disableCheckBoxes,
      currentPage,
      pageSize,
    } = this.state;

    const isLastItem = (( posts.length - 1 ) === ((currentPage * pageSize) + index)) ? true : false;

    return (
      <PostListItem
        key={post._id}
        allChecked={allChecked}
        {...post}
        postCategory={postCategory}
        handleDuplicate={this.handleDuplicate}
        handleDelete={this.handleDeleteModule}
        handleSelected={this.handleSelected}
        disableCheckBoxes={disableCheckBoxes}
        reusablePosts={reusablePosts}
        isLastItem={isLastItem}
      />
    )
  }

  componentDidMount() {
    this.timer = null;
  }

  pagination = () => {

    const { currentPage, pageSize, currentPageValue } = this.state;
    const { posts } = this.props;

    const pageControlStyle = `p-2 rounded border cursor-pointer uppercase mr-1 `;
    const hasNext = `${(((currentPage * pageSize) + pageSize) > posts.length) ? ' bg-grey hover:bg-grey text-white hover:text-white cursor-not-allowed' : ' hover:bg-blue-darker bg-blue-lighter text-black hover:text-white'}`;
    const hasPrev = `${(currentPage <= 0) ? ' bg-grey hover:bg-grey text-white hover:text-white cursor-not-allowed' : ' hover:bg-blue-darker bg-blue-lighter text-black hover:text-white'}`;

    const substractPage = () => {
      const pageToGo = currentPage - 1;
      if (pageToGo >= 0)
      this.setState({ currentPageValue: pageToGo, currentPage: pageToGo });
    }

    const addPage = () => {
      const pageToGo = currentPage + 1
      if (pageToGo <= parseInt(posts.length / pageSize))
      this.setState({ currentPageValue: pageToGo, currentPage: pageToGo });
    }

    const changePageIndicator = (e) => {
      clearTimeout(this.timer);
      this.setState({ currentPageValue: e.target.value });
      this.timer = setTimeout(gotoPage, 1000);
    }

    const changePageIndicatorKey = (e) => {
      if(e.keyCode === 13){
        gotoPage()
      }
    }

    const gotoPage = () => this.setState({ currentPage: this.state.currentPageValue });

    return (
      <>
        <div className="p-2 rounded flex items-center justify-center font-americaMonoBold text-xs">
          <div className={[pageControlStyle, hasPrev]} onClick={substractPage}>PREV</div>
          <input className="border rounded w-12 p-2 uppercase mr-1 text-center" type="text"
            value={currentPageValue}
            onChange={changePageIndicator}
            onKeyDown={changePageIndicatorKey} />
          <div className={[pageControlStyle, hasNext]} onClick={addPage}>NEXT</div>
        </div>
      </>
    )
  }

  render() {
    const {
      isDeleteModuleOn,
      isDeleteConfirmationModuleOn,
      statusText,
      postItemsSelected,
      allChecked,
      disableCheckBoxes,
      isDuplicatingModuleOn,
      duplicatedPost,
      slugName,
      currentPage,
      pageSize,
    } = this.state;
    const { posts, reusablePosts } = this.props;

    return (
      <>
        {!reusablePosts && (
          <div className="flex items-center pl-3 pr-8 bg-blue-lighter rounded justify-between ">
            <div>
              <Checkbox
                checked={allChecked}
                disabled={disableCheckBoxes}
                onChange={this.handleAllCheckedChange}
                value="checkedA"
                inputProps={{
                  'aria-label': 'primary checkbox',
                }}
              />
              <span className=" font-americaMonoBold text-black uppercase text-xs ">Check All!</span>
            </div>
            {(postItemsSelected.length > 1)
              && (
                <div className="flex">
                  <button className="font-americaMonoBold
                    px-6 py-2 rounded-full text-white uppercase
                    text-xs flex items-center bg-green-pin"
                  type="button"
                  onClick={() => this.handleArrayActivation(true)}>publish</button>
                  <button className="ml-2 font-americaMonoBold px-6 py-2 rounded-full  text-white uppercase text-xs flex items-center bg-black" type="button" onClick={() => this.handleArrayActivation(false)}>unpublish</button>
                </div>
              )}
          </div>
        )}
        {
          (posts && posts.length > pageSize) && this.pagination()
        }
        {
          (posts && posts.length) && (
            posts.slice(
              (currentPage * pageSize),
              (
                ((currentPage * pageSize) + pageSize) <= (posts.length) ?
                ((currentPage * pageSize) + pageSize) :
                (posts.length)
              )
            ).map(this.showPosts)
          )
        }
        {
          isDeleteModuleOn && (
            <Modal
              handleClick={() => {
                this.setState({ isDeleteModuleOn: false });
              }}
              positionMiddle
            >
              <div className="flex flex-col items-center justify-center p-4">
                <span className="font-americaMonoRegular text-xs uppercase">Are you sure you want to Delete?</span>
                <div className=" flex justify-between p-4 w-1/3 items-center">
                  <button className="bg-white" type="button" onClick={this.handleDelete}>
                    Yes
                  </button>
                  <button
                    className="bg-white"
                    type="button"
                    onClick={() => {
                      this.setState({ isDeleteModuleOn: false });
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            </Modal>
          )
        }
        {
          isDeleteConfirmationModuleOn && (
            <Modal
              handleClick={() => {
                this.setState({ isDeleteConfirmationModuleOn: false, statusText: '' });
              }}
              positionMiddle
            >
              <div className="flex flex-col items-center justify-center p-4">
                <span className="font-americaMonoRegular text-xs uppercase">{statusText}</span>
                <div className=" flex p-4 w-1/3 items-center">
                  <button
                    className="bg-white"
                    type="button"
                    onClick={() => {
                      this.setState({ isDeleteConfirmationModuleOn: false, statusText: '' });
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Modal>
          )
        }
        {
          isDuplicatingModuleOn && (
            <Modal
              title={`Duplicate post: ${slugName}`}
              handleClick={() => {
                this.setState({ isDuplicatingModuleOn: false, statusText: '' });
              }}
            >
              <div className="flex flex-col items-center px-4">
                <label className="font-americaMonoRegular text-xs uppercase my-2 w-full" htmlFor="slugName">
                  Post title (en)
                  <input className="font-americaMonoRegular p-2 bg-white outline-none w-full mt-4 rounded-full" onChange={this.handleSetNewSlugName} name="slugName" type="text" value={duplicatedPost.postName} placeholder="Name of new post" />
                  <span className="font-americaMonoRegular text-xs p-2 pl-0 block">
                    Slugname:
                    <span className="lowercase ml-2">{duplicatedPost.slugName}</span>
                  </span>
                </label>
                <div className="flex justify-between w-full pb-6 flex-wrap">
                  <p className="font-americaMonoRegular text-xs uppercase text-red m-0 p-0">{statusText}</p>
                  <button className="self-end font-americaMonoBold text-xs px-6 py-2 rounded-full bg-white text-black uppercase ml-7 mt-2 " onClick={() => this.handleDuplicatedPostSave()} type="button">Save new post</button>
                </div>
              </div>
            </Modal>
          )
        }
      </>
    );
  }
}

PostsList.propTypes = {
  postCategory: PropTypes.string.isRequired,
  match: PropTypes.shape().isRequired,
  posts: PropTypes.arrayOf(PropTypes.shape({})),
  updatePostsList: PropTypes.func.isRequired,
  reusablePosts: PropTypes.bool,
};

PostsList.defaultProps = {
  posts: null,
  reusablePosts: false,
};

export default withRouter(PostsList);
